import { z } from "zod";

export function zodEnum<EnumValue extends string>(
  e: Record<string | number, EnumValue>
): z.ZodEnum<[EnumValue, ...EnumValue[]]> {
  const values = Object.values(e);
  if (!values.length) {
    throw new Error("Enum has no values");
  }
  return z.enum(values as [EnumValue, ...EnumValue[]]);
}
